import { ElementRef, QueryList } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FeText } from '../ui-elements/form-elements/fe-text/fe-text';
import { FeCheckbox } from '../ui-elements/form-elements/fe-checkbox/fe-checkbox';
import { FeRadio } from '../ui-elements/form-elements/fe-radio/fe-radio';
import { FeRadioGroup } from '../ui-elements/form-elements/fe-radio-group/fe-radio-group';
import { FeButton } from '../ui-elements/form-elements/fe-button/fe-button';
import { FeSwitcher } from '../ui-elements/form-elements/fe-switcher/fe-switcher';
import { FeSelect } from '../ui-elements/form-elements/fe-select/fe-select';
import { UiFormGroup } from '../ui-elements/ui-form-group/ui-form-group';
import { CagefsComponent } from '../../cagefs-plugin/cagefs.component';
import { NodeJSIndexComponent } from '../../nodejs/index.component';
import { UiFormElement } from '../ui-elements/ui-form-element/ui-form-element';
import { GroupedGrid } from '../grouped_grid';
import { Caption } from '../../model/caption';
import { Helper } from '../helper';
import { TranslateClass } from '../pipes/translate';

export class Filterable {

    public elementRef: ElementRef;
    public title;
    public description;
    public caption: Caption;
    public feTextList: QueryList<FeText>;
    public feCheckboxList: QueryList<FeCheckbox>;
    public feRadioList: QueryList<FeRadio>;
    public feRadioGroupList: QueryList<FeRadioGroup>;
    public feButtonList: QueryList<FeButton>;
    public feSwitcherList: QueryList<FeSwitcher>;
    public feSelectList: QueryList<FeSelect>;
    public uiFormGroupList: QueryList<UiFormGroup>;
    public cagefsComponent: CagefsComponent;
    public nodejsComponent: NodeJSIndexComponent;
    public uiFormElement: UiFormElement;
    public groupedGrid: GroupedGrid;
    public routerOutlet: RouterOutlet;

    public numFound: number = 0;

    public showAll(): void {
        this.childComponents().forEach(child => {
            child.forEach(item => item.show());
        });
        this.parentComponents().forEach(parent => {
            parent.forEach(item => item.showAll());
        });
        this.show();
    }

    public filterByText (text: string): boolean {
        this.numFound = 0;

        if (!text) {
            this.showAll();
            return true;
        }

        let hasTextInChildren = this.childComponents().map(child => {

                return child.map(item => {
                    let hasText = item.hasTextInTitleOrDescription(text);
                    item.toggleItem(hasText);
                    if (hasText) {
                        this.numFound += item.textOccurrencesInTitle(text)
                            + item.textOccurrencesInDescription(text)
                            + item.textOccurrencesInCaption(text);
                    }
                    return hasText;
                }).some(condition => condition === true);

            }).some(condition => condition === true);

        let hasTextInParents = this.parentComponents().map(parent => {

            return parent.map(item => {
                let hasText = item.filterByText(text) || item.hasTextInTitleOrDescription(text);
                if (hasText) {
                    item.showAll();
                } else {
                    this.hide();
                }
                this.numFound += item.numFound;
                return hasText;
            }).some(condition => condition === true);

        }).some(condition => condition === true);

        if (this.hasTextInTitleOrDescription(text)) {
            this.numFound += this.textOccurrencesInTitle(text)
                + this.textOccurrencesInDescription(text)
                + this.textOccurrencesInCaption(text);
            this.showAll();
        }

        let containPhrase = hasTextInChildren
            || hasTextInParents
            || this.hasTextInTitleOrDescription(text);

        this.toggleItem(containPhrase);

        return containPhrase;
    }

    private show(): void {
        if (this.elementRef) {
            this.elementRef.nativeElement.classList.remove('hidden');
        }
    }

    private hide(): void {
        if (this.elementRef) {
            this.elementRef.nativeElement.classList.add('hidden');
        }
    }

    private toggleItem(isShow): void {
        if (isShow) {
            this.show();
        } else {
            this.hide();
        }
    }

    private parentComponents(): any[] {
        return [
            this.uiFormGroupList ? this.uiFormGroupList.toArray() : [],
            this.feRadioGroupList ? this.feRadioGroupList.toArray() : [],
            this.cagefsComponent ? [this.cagefsComponent] : [],
            this.nodejsComponent ? [this.nodejsComponent] : [],
            this.groupedGrid ? [this.groupedGrid] : []
        ];
    }

    private childComponents(): any[] {
        return [
            this.feButtonList ? this.feButtonList.toArray() : [],
            this.feCheckboxList ? this.feCheckboxList.toArray() : [],
            this.feRadioList ? this.feRadioList.toArray() : [],
            this.feSelectList ? this.feSelectList.toArray() : [],
            this.feSwitcherList ? this.feSwitcherList.toArray() : [],
            this.feTextList ? this.feTextList.toArray() : [],
            this.uiFormElement ? [this.uiFormElement] : [],
            this.routerOutlet && this.routerOutlet.isActivated ? [this.routerOutlet.component] : [],
        ];
    }

    private textOccurrencesInTitle(text: string = ''): number {
        try {
            text = Helper.convertStringToHexRepresentation(String(text));
            let title = new TranslateClass().transform(this.title);
            return ((title || '').match(new RegExp(text, 'gi')) || []).length;
        } catch (e) {
            return 0;
        }
    }

    private textOccurrencesInDescription(text: string = ''): number {
        try {
            text = Helper.convertStringToHexRepresentation(String(text));
            let description = new TranslateClass().transform(this.description);
            return ((description || '').match(new RegExp(text, 'gi')) || []).length;
        } catch (e) {
            return 0;
        }
    }

    private textOccurrencesInCaption(text: string = ''): number {
        try {
            text = Helper.convertStringToHexRepresentation(String(text));
            return this.caption
                ? ((new TranslateClass().transform(this.caption.title) || '')
                    .match(new RegExp(text, 'gi')) || []).length
                : 0;
        } catch (e) {
            return 0;
        }
    }

    private hasTextInTitleOrDescription(text: string = ''): boolean {
        return !!this.textOccurrencesInTitle(text)
            || !!this.textOccurrencesInDescription(text)
            || !!this.textOccurrencesInCaption(text);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/mixins/Filterable.ts